import * as React from 'react';
import { Helmet } from 'react-helmet';

const GoogleOptimize = (): JSX.Element => {
  return (
    <Helmet>
      <script>{`
          ;(function (a, s, y, n, c, h, i, d, e) {
            s.className += " " + y
            h.start = 1 * new Date()
            h.end = i = function () {
              s.className = s.className.replace(RegExp(" ?" + y), "")
            }
            ;(a[n] = a[n] || []).hide = h
            setTimeout(function () {
              i()
              h.end = null
            }, c)
            h.timeout = c
          })(window, document.documentElement, "async-hide", "dataLayer", 1000, { "OPT-M72MJQX": true })
        `}</script>
      <script async src="https://www.googleoptimize.com/optimize.js?id=OPT-M72MJQX"></script>
      <style>{`
          .async-hide {
            opacity: 0 !important;
          }
        `}</style>
    </Helmet>
  );
};

export default GoogleOptimize;
